import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getEditableUser, getUsers, createUser, editUser, getDemoRecreateUsers } from './userManagementActions';

const initialState = {
  usersTab: 0,

  isLoading: false,
  editableUser: {},
  usersList: [],
  tableSettings: {
    page: 0,
    size: 10,
    sort: '-createdOn',
    totalElements: 0,
  },

  demoRecreateUsers: [],
  demoRecreateTableSettings: {
    page: 0,
    size: 10,
    query: '',
    sort: '-createdOn',
    totalElements: 0,
  },
  demoRecreateIsLoading: false,
};

const securitySlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    resetEditableUser: (state) => {
      state.editableUser = {};
    },
    changeTablePage: (state, action) => {
      state.tableSettings.page = action.payload;
    },
    changeTableSize: (state, action) => {
      state.tableSettings.size = action.payload;
      state.tableSettings.page = 0;
    },
    changeDemoRecreateTableSettings: (state, action) => {
      state.demoRecreateTableSettings = { ...state.demoRecreateTableSettings, ...action.payload };
    },
    changeTableSort: (state, action) => {
      state.tableSettings.sort = action.payload;
      state.tableSettings.page = 0;
    },
    changeEditableUser: (state, action) => {
      state.editableUser = action.payload;
    },
    changeUsersTab: (state, action) => {
      state.usersTab = action.payload;
    },
    resetParams: () => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEditableUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.editableUser = action.payload;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.usersList = action.payload.content;
        state.tableSettings.totalElements = action.payload.total;
      })

      .addCase(getDemoRecreateUsers.fulfilled, (state, action) => {
        state.demoRecreateIsLoading = false;
        state.demoRecreateUsers = action.payload.content;
        state.demoRecreateTableSettings.totalElements = action.payload.total;
      })
      .addCase(getDemoRecreateUsers.pending, (state) => {
        state.demoRecreateIsLoading = true;
      })
      .addCase(getDemoRecreateUsers.rejected, (state) => {
        state.demoRecreateIsLoading = false;
      })

      .addMatcher(isAnyOf(createUser.fulfilled, editUser.fulfilled), (state) => {
        state.isLoading = false;
      })
      .addMatcher(isAnyOf(getEditableUser.pending, getUsers.pending, createUser.pending, editUser.pending), (state) => {
        state.isLoading = true;
      })
      .addMatcher(
        isAnyOf(getEditableUser.rejected, getUsers.rejected, createUser.rejected, editUser.rejected),
        (state) => {
          state.isLoading = false;
        },
      );
  },
});

export const {
  resetEditableUser,
  changeTablePage,
  changeTableSize,
  resetParams,
  changeTableSort,
  changeEditableUser,
  changeUsersTab,
  changeDemoRecreateTableSettings,
} = securitySlice.actions;

export default securitySlice.reducer;
